import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: { name: 'form-page' },
        meta: {
            title: 'Simple CV - Free Online Resume Builder',
            description: 'Create professional resumes and CVs in minutes with our free online builder.',
        },
    },
    {
        path: '/cv-form',
        name: 'form-page',
        component: () => import('@/views/FormPage.vue'),
        meta: {
            title: 'Create Your CV - Simple CV Builder',
            description: 'Fill in your details to create a professional CV. Easy-to-use form with real-time preview.',
        },
    },
    {
        path: '/cv',
        name: 'cv-page',
        component: () => import('@/views/CvPage.vue'),
        meta: {
            title: 'Your CV Preview - Simple CV',
            description: 'Preview and download your professionally designed CV.',
        },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

// Base URL for canonical links
const BASE_URL = 'https://simplecv.lunacore.space'

// Dynamic page titles, meta descriptions, and canonical URLs for SEO
router.beforeEach((to, from, next) => {
    // Update document title
    document.title = to.meta.title || 'Simple CV - Free Online Resume Builder'

    // Update meta description
    const descriptionMeta = document.querySelector('meta[name="description"]')
    if (descriptionMeta) {
        descriptionMeta.setAttribute('content', to.meta.description || 'Create professional resumes and CVs in minutes.')
    }

    // Update canonical URL to match current page
    const canonicalLink = document.querySelector('link[rel="canonical"]')
    if (canonicalLink) {
        canonicalLink.setAttribute('href', `${BASE_URL}${to.path}`)
    }

    // Update Open Graph URL
    const ogUrl = document.querySelector('meta[property="og:url"]')
    if (ogUrl) {
        ogUrl.setAttribute('content', `${BASE_URL}${to.path}`)
    }

    // Update Twitter URL
    const twitterUrl = document.querySelector('meta[name="twitter:url"]')
    if (twitterUrl) {
        twitterUrl.setAttribute('content', `${BASE_URL}${to.path}`)
    }

    next()
})

export default router
